import React, {createContext, useCallback, useContext, useMemo, useState} from 'react';
import PropTypes from "prop-types";

const SidebarContext = createContext();

export const useSidebar = () => useContext(SidebarContext);

export const SidebarProvider = ({children}) => {
  const [sidebarContent, setSidebarContent] = useState(null);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSidebar = useCallback(() => setIsCollapsed(prev => !prev), []);

  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const toggleMobileSidebar = useCallback(() => setIsMobileOpen(prev => !prev), []);

  const setContent = useCallback((content) => {
    setSidebarContent(content);
  }, []);

  const value = useMemo(() => ({
    sidebarContent,
    setContent,
    isCollapsed,
    toggleSidebar,
    setIsCollapsed,
    isMobileOpen,
    toggleMobileSidebar,
    setIsMobileOpen
  }), [sidebarContent, setContent, isCollapsed, toggleSidebar, isMobileOpen, toggleMobileSidebar]);

  return (
    <SidebarContext.Provider value={value}>
      {children}
    </SidebarContext.Provider>
  );
};

SidebarProvider.propTypes = {
  children: PropTypes.node.isRequired
};